import React from 'react'
import { SET_CONFIG } from '../actionTypes'

export interface IConfig {
  theme: string
  sidebarOpen: boolean
}

interface IAction {
  type: string
  payload: IConfig
}

const initialState: IConfig = {
  theme: 'light',
  sidebarOpen: true,
}

const configReducer: React.Reducer<IConfig, IAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_CONFIG:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export default configReducer
